import { ChartMark, WidgetKind, type Report } from 'corso-admin-ui';

export const overview = {
  key: 'overview',
  label: 'Overview',
  dataset: 'orderEdits',
  timeFields: ['createdOn'],
  widgets: [
    { kind: WidgetKind.kpi, metric: 'edits' },
    {
      kind: WidgetKind.kpi,
      metric: 'minutesSaved',
      description: 'Estimated support time saved',
    },
    { kind: WidgetKind.kpi, metric: 'newRevenue' },
    {
      kind: WidgetKind.overTime,
      title: 'Order edits over time',
      mark: ChartMark.line,
      metrics: ['edits'],
    },
    {
      kind: WidgetKind.table,
      title: 'Edit types',
      dimensions: ['editType'],
      metrics: ['edits', 'minutesSaved'],
    },
    {
      kind: WidgetKind.table,
      title: 'Most edited orders',
      description: 'By order and edit type',
      dimensions: ['orderId', 'editType'],
      metrics: ['edits', 'minutesSaved'],
      limit: 50,
    },
  ],
} as const satisfies Report;
